// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2TXtf","boxTitle":"Qualiphy_boxTitle__34bwo","box":"Qualiphy_box__89tvC","toggleWrap":"Qualiphy_toggleWrap__1c2mv"};